/*-----------------------------------------------------------------------------------
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
 *-----------------------------------------------------------------------------------*/

export interface LoadingState {
  isPackageListLoading: boolean
  isBuyReactLoading: boolean
}

export const createLoadingStata = (): LoadingState => {
  return {
    isPackageListLoading: false,
    isBuyReactLoading: false,
  } as unknown as LoadingState
}

export default {
  state: createLoadingStata(),
  mutations: {
    setPackageListLoading(state: LoadingState, payload: boolean) {
      state.isPackageListLoading = payload
    },
    setBuyReactLoading(state: LoadingState, payload: boolean) {
      state.isBuyReactLoading = payload
    },
  },
  getters: {
    isPackageDataLoading(state: LoadingState): boolean {
      return state.isPackageListLoading || state.isBuyReactLoading
    },
  },
}
